<template>
  <div class="mt-5">
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="selected_year"
          :items="years"
          :item-value="(item) => item['year']"
          :item-text="(item) => objectTranslatorLowerCase(item, 'year')"
          outlined
          dense
          :label="$t('config_teach_table.year')"
          hide-details
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selected_semester"
          :items="semesters"
          outlined
          dense
          :label="$t('config_teach_table.semester')"
          hide-details
        />
      </v-col>
    </v-row>
    <autocomplete
      :data="faculties"
      :label="$t('config_teach_table.faculty')"
      data_id="FACULTY_ID"
      data_name="NAME"
      :selected_value="selected_faculty"
      @update_selected_value="(val) => (selected_faculty = val)"
      :can_select_all="false"
      :lower_case="false"
    />
    <autocomplete
      :data="filteredDepartments"
      data_id="department_id"
      data_name="department_name"
      :label="$t('config_teach_table.department')"
      :selected_value="selected_department"
      @update_selected_value="(val) => (selected_department = val)"
      :can_select_all="false"
      :lower_case="true"
    />
    <autocomplete
      :data="filteredCurriculums"
      :data_id="isGraduate ? 'REGISTRAR_CURRICULUM_ID' : 'REGISTRAR_CURRICULUM2_ID'"
      data_name="SHORT_NAME"
      :label="$t(isGraduate ? 'teach_table.major' : 'config_teach_table.curriculum')"
      :search_all_label="$t(isGraduate ? 'teach_table.select_all_major' : 'teach_table.select_all_curriculum')"
      :disable_select_all="!selected_department"
      :selected_value="selected_curriculum"
      @update_selected_value="(val) => (selected_curriculum = val)"
      :select_searh_all="search_all_curriculum"
      @update_select_search_all_value="(val) => (search_all_curriculum = val)"
      :can_select_all="true"
      :lower_case="false"
    />
    <autocomplete
      v-if="!isGraduate"
      :data="class_years"
      :label="$t('config_teach_table.class')"
      :search_all_label="$t('teach_table.select_all_class')"
      :selected_value="selected_class_year"
      @update_selected_value="(val) => (selected_class_year = val)"
      :select_searh_all="search_all_class_year"
      @update_select_search_all_value="(val) => (search_all_class_year = val)"
      :can_select_all="true"
      :lower_case="true"
    />
    <autocomplete
      v-else-if="!graduateCurriculumHasNoBranches"
      :data="filteredBranches"
      :label="$t('teach_table.graduate_branch')"
      data_id="branch_id"
      data_name="branch_name"
      :selected_value="selected_branch"
      @update_selected_value="(val) => (selected_branch = val)"
      :search_all_label="$t('teach_table.select_all_branch')"
      :select_searh_all="search_all_branch"
      @update_select_search_all_value="(val) => (search_all_branch = val)"
      :can_select_all="true"
      :lower_case="true"
    />
    <template v-if="isGraduate">
      <autocomplete
        :data="admissionTypeOptions"
        data_id="value"
        data_name="text"
        :label="$t('teach_table.admission_type')"
        :search_all_label="$t('teach_table.select_all_admission_type')"
        :selected_value="selected_admission_type"
        @update_selected_value="(val) => (selected_admission_type = val)"
        :select_searh_all="search_all_admission_type"
        @update_select_search_all_value="(val) => (search_all_admission_type = val)"
        :can_select_all="true"
        :lower_case="true"
      />
      <autocomplete
        :data="admissionSemesterOptions"
        data_id="value"
        data_name="text"
        :label="$t('teach_table.admission_semester')"
        :search_all_label="$t('teach_table.select_all_admission_semester')"
        :selected_value="selected_admission_semester"
        @update_selected_value="(val) => (selected_admission_semester = val)"
        :select_searh_all="search_all_admission_semester"
        @update_select_search_all_value="(val) => (search_all_admission_semester = val)"
        :can_select_all="true"
        :lower_case="true"
      />
    </template>

    <v-divider class="mt-2"></v-divider>
    <v-btn
      block
      large
      color="blue"
      class="mt-3 white--text"
      :disabled="!searchButtonEnable"
      v-on:click="submit"
      >{{ $t("teach_table.search") }}
    </v-btn>

    <v-btn
      v-if="check_permission(['config_teach_table'])"
      block
      large
      color="green"
      class="mt-3 white--text"
      :disabled="!addButtonEnable || !configurable"
      v-on:click="add"
      >{{ $t("teach_table.add_course_to_curr_class") }}</v-btn
    >

    <div
      class="pt-2"
      v-if="
        addButtonEnable &&
        !configurable &&
        check_permission(['config_teach_table'])
      "
    >
      <p class="red--text text-center pa-0 ma-0">
        ไม่มีสิทธิ์ตั้งค่าตารางสอนในคณะและปีการศึกษานี้
        โปรดติดต่อเจ้าหน้าที่สำนักทะเบียนฯ
      </p>
    </div>
  </div>
</template>

<script>
import Autocomplete from "./components/Autocomplete.vue";
import { check_permission } from "@/router/acl";
import { objectTranslatorLowerCase } from "@/helper/translator";

export default {
  components: { Autocomplete },
  name: "TeachTableSelectorByClass",
  props: {
    years: Array,
    semesters: Array,
    class_years: Array,
    faculties: Array,
    departments: Array,
    curriculums: Array,
    branches: Array,
    admission_types: Array,
    admission_semesters: Array,
    config_permission: Object,
    level_id: { type: Number, default: 1 },
  },
  data: () => ({
    selected_year: null,
    selected_semester: null,
    selected_class_year: null,
    selected_faculty: null,
    selected_curriculum: null,
    selected_department: null,
    selected_branch: null,
    selected_admission_type: null,
    selected_admission_semester: null,

    search_all_curriculum: false,
    search_all_class_year: false,
    search_all_branch: false,
    search_all_admission_type: false,
    search_all_admission_semester: false,
  }),
  computed: {
    isGraduate() {
      return Number(this.level_id) > 1;
    },
    filteredDepartments() {
      if (!this.selected_faculty) return [];
      return this.departments.filter(
        (item) => item.faculty_id === this.selected_faculty
      );
    },
    filteredCurriculums() {
      if (!this.selected_department) return [];
      return this.curriculums.filter(
        (item) =>
          item.FACULTY_ID === this.selected_faculty &&
          item.REGISTRAR_DEPARTMENT_ID === this.selected_department
      );
    },
    filteredBranches() {
      if (!this.selected_curriculum) return [];
      return (this.branches || []).filter(
        (item) =>
          String(item.branch_id || "").trim() !== "" &&
          item.faculty_id === this.selected_faculty &&
          item.curriculum_id === this.selected_curriculum
      );
    },
    graduateCurriculumHasNoBranches() {
      return Boolean(
        this.isGraduate &&
          this.selected_curriculum &&
          this.filteredBranches.length === 0
      );
    },
    admissionTypeOptions() {
      return this.admission_types || [];
    },
    admissionSemesterOptions() {
      return (this.admission_semesters || []).map((value) => ({
          value,
          text_th: String(value),
          text_en: String(value),
        }));
    },
    searchButtonEnable() {
      if (this.isGraduate) {
        return Boolean(
          this.selected_year &&
            this.selected_semester &&
            this.selected_faculty &&
            this.selected_department &&
            (this.selected_curriculum || this.search_all_curriculum) &&
            (this.graduateCurriculumHasNoBranches ||
              this.selected_branch ||
              this.search_all_branch) &&
            (this.selected_admission_type || this.search_all_admission_type) &&
            (this.selected_admission_semester ||
              this.search_all_admission_semester)
        );
      }
      return (
        this.selected_year &&
        this.selected_semester &&
        this.selected_faculty &&
        this.selected_department &&
        (this.selected_curriculum || this.search_all_curriculum) &&
        (this.selected_class_year || this.search_all_class_year)
      );
    },
    addButtonEnable() {
      if (this.isGraduate) {
        return Boolean(
          this.selected_year &&
            this.selected_semester &&
            this.selected_faculty &&
            this.selected_department &&
            (this.selected_curriculum || this.search_all_curriculum) &&
            (this.graduateCurriculumHasNoBranches ||
              this.selected_branch || this.search_all_branch) &&
            (this.selected_admission_type || this.search_all_admission_type) &&
            (this.selected_admission_semester || this.search_all_admission_semester)
        );
      }
      return (
        this.selected_year &&
        this.selected_semester &&
        this.selected_faculty &&
        this.selected_department &&
        (this.selected_curriculum || this.search_all_curriculum) &&
        (this.selected_class_year || this.search_all_class_year)
      );
    },
    configurable() {
      return (
        ((this.config_permission.academic_year.some(
          (item) =>
            item.LEVEL_ID == this.level_id &&
            item.YEAR == this.selected_year &&
            item.SEMESTER == this.selected_semester
        ) || (this.config_permission.special_periods || []).some(
          (item) => item.LEVEL_ID == this.level_id &&
            item.FACULTY_ID == this.selected_faculty &&
            item.YEAR == this.selected_year && item.SEMESTER == this.selected_semester
        )) &&
          this.config_permission.user_permission.some(
            (item) =>
              item.LEVEL_ID == this.level_id &&
              (item.FACULTY_ID == this.selected_faculty ||
                item.FACULTY_ID == "AL")
          )) ||
        this.$store.state.user.is_authorized_officer === true
      );
    },
  },
  methods: {
    check_permission,
    objectTranslatorLowerCase,
    add() {
      let routeData = this.$router.resolve({
        name: "config_teach_table",
        query: {
          year: this.selected_year,
          semester: this.selected_semester,
          faculty_id: this.selected_faculty,
          dept_id: this.selected_department,
          curr2_id: this.isGraduate ? null : this.selected_curriculum,
          curr_id: this.isGraduate
            ? (this.search_all_curriculum ? 'x' : this.selected_curriculum)
            : null,
          branch_id:
            this.isGraduate && this.graduateCurriculumHasNoBranches
              ? null
              : (this.isGraduate && this.search_all_branch ? 'x' : this.selected_branch),
          admission_type: this.isGraduate
            ? (this.search_all_admission_type ? 'x' : this.selected_admission_type)
            : null,
          admission_semester: this.isGraduate
            ? (this.search_all_admission_semester ? 'x' : this.selected_admission_semester)
            : null,
          class: this.isGraduate ? null : this.selected_class_year,
          level_id: this.level_id,
          command: "create",
        },
      });
      window.open(routeData.href, "_blank").focus();
    },
    submit() {
      const allGraduateCurriculums =
        this.isGraduate && this.search_all_curriculum;
      const allGraduateBranches =
        this.isGraduate &&
        (this.search_all_branch || this.graduateCurriculumHasNoBranches);
      const allGraduateAdmissionTypes =
        this.isGraduate && this.search_all_admission_type;
      const allGraduateAdmissionSemesters =
        this.isGraduate && this.search_all_admission_semester;
      let routeData = this.$router.resolve({
        name: this.isGraduate ? "graduate_teach_table" : "teach_table",
        query: {
          level_id: this.level_id,
          mode: this.isGraduate ? "by_curriculum" : "by_class",
          selected_year: this.selected_year,
          selected_semester: this.selected_semester,
          selected_faculty: this.selected_faculty,
          selected_department: this.selected_department,
          selected_curriculum: allGraduateCurriculums
            ? null
            : this.selected_curriculum,
          selected_branch: allGraduateBranches ? null : this.selected_branch,
          selected_class_year: this.isGraduate ? "0" : this.selected_class_year,
          search_all_faculty: false,
          search_all_department: false,
          search_all_curriculum: this.isGraduate
            ? allGraduateCurriculums
            : this.search_all_curriculum,
          search_all_branch: this.isGraduate ? allGraduateBranches : true,
          search_all_class_year: this.isGraduate ? true : this.search_all_class_year,
          selected_admission_type: allGraduateAdmissionTypes
            ? null
            : this.selected_admission_type,
          selected_admission_semester: allGraduateAdmissionSemesters
            ? null
            : this.selected_admission_semester,
        },
      });
      window.open(routeData.href, "_blank").focus();
    },
  },
  created() {
    // const saved_year = window.sessionStorage.getItem(
    //   "reg_teach_table_search__year"
    // );
    // if (saved_year && this.years.includes(saved_year))
    //   this.selected_year = saved_year;
    // const saved_semester = window.sessionStorage.getItem(
    //   "reg_teach_table_search__semester"
    // );
    // if (saved_semester && this.semesters.includes(saved_semester))
    //   this.selected_semester = saved_semester;
  },
  watch: {
    level_id() {
      this.selected_year = null;
      this.selected_semester = null;
      this.selected_class_year = null;
      this.selected_faculty = null;
      this.selected_department = null;
      this.selected_curriculum = null;
      this.selected_branch = null;
      this.selected_admission_type = null;
      this.selected_admission_semester = null;
      this.search_all_curriculum = false;
      this.search_all_class_year = false;
      this.search_all_branch = false;
      this.search_all_admission_type = false;
      this.search_all_admission_semester = false;
    },
    selected_faculty() {
      this.selected_department = null;
      this.selected_curriculum = null;
      this.selected_branch = null;
    },
    selected_department() {
      this.selected_curriculum = null;
      this.selected_branch = null;
      if (!this.isGraduate && this.search_all_curriculum) {
        this.selected_curriculum = "x";
      }
    },
    selected_curriculum(value) {
      this.selected_branch = null;
      if (this.isGraduate && value) this.search_all_branch = false;
    },
    selected_year() {
      if (this.isGraduate) {
        this.selected_faculty = null;
        this.selected_department = null;
        this.selected_curriculum = null;
        this.selected_branch = null;
      }
    },
    selected_semester() {
      if (this.isGraduate) {
        this.selected_faculty = null;
        this.selected_department = null;
        this.selected_curriculum = null;
        this.selected_branch = null;
      }
    },
    search_all_curriculum(val) {
      if (val) {
        this.selected_curriculum = this.isGraduate ? null : "x";
        if (this.isGraduate) this.search_all_branch = true;
      } else if (this.isGraduate) {
        this.search_all_branch = false;
      }
    },
    search_all_class_year(val) {
      if (val) {
        this.selected_class_year = "0";
      } else {
        this.selected_class_year = null;
      }
    },
    search_all_branch(val) {
      if (val) this.selected_branch = null;
    },
    search_all_admission_type(val) {
      if (val) this.selected_admission_type = null;
    },
    search_all_admission_semester(val) {
      if (val) this.selected_admission_semester = null;
    },
    // selected_year(val) {
    //   window.sessionStorage.setItem("reg_teach_table_search__year", val);
    // },
    // selected_semester(val) {
    //   window.sessionStorage.setItem("reg_teach_table_search__semester", val);
    // },
  },
};
</script>

<style></style>
